// The exhibit — the concrete artifact the learner is asked to examine (an AI
// draft, an email, a report excerpt), rendered as a document IN the scene
// rather than narrated about. Neutral presentation for the standard themed
// renderers; the flagship world skins (RisographPerspectiveLenses,
// NeonOracleScenarioSim) dress their own in-register instead of using this.
// See ScenarioExhibit in slideTypes.ts for why this field exists.

import type { ScenarioExhibit } from '../slideTypes';
import type { Theme } from '../slideTypes';

const KIND_LABELS: Record<ScenarioExhibit['kind'], string> = {
  document: 'Document',
  draft: 'Draft',
  email: 'Email',
  message: 'Message',
  report: 'Report',
  transcript: 'Transcript',
  data: 'Data',
  other: 'Exhibit',
};

export function ExperienceExhibit({ exhibit, theme }: { exhibit: ScenarioExhibit; theme: Theme }) {
  return (
    <figure
      className="rounded-md border mb-6"
      style={{
        background: theme.colors.background,
        borderColor: `${theme.colors.textMuted}55`,
        boxShadow: `2px 3px 0 ${theme.colors.textMuted}22`,
        margin: 0,
        marginBottom: 24,
      }}
    >
      <figcaption
        className="flex items-baseline gap-2 px-4 py-2 border-b"
        style={{ borderColor: `${theme.colors.textMuted}33` }}
      >
        <span
          className="text-[10px] uppercase tracking-widest font-bold"
          style={{ color: theme.colors.accent }}
        >
          {KIND_LABELS[exhibit.kind]}
        </span>
        {exhibit.title && (
          <span className="text-xs font-semibold" style={{ color: theme.colors.text }}>
            {exhibit.title}
          </span>
        )}
      </figcaption>
      <div
        className="px-4 py-3 text-sm leading-relaxed whitespace-pre-line"
        style={{ color: theme.colors.text, fontFamily: theme.fonts.body }}
      >
        {exhibit.body}
      </div>
      {exhibit.attribution && (
        <div
          className="px-4 pb-3 text-[11px] italic"
          style={{ color: theme.colors.textMuted }}
        >
          {exhibit.attribution}
        </div>
      )}
    </figure>
  );
}
